/**
 * Cover Generation Modal Component
 * Modal for AI-powered cover generation
 */
import React from 'react';
import { ImagePlus, Sparkles, X } from 'lucide-react';

export function CoverGenerationModal({
  isOpen,
  onClose,
  coverTitle,
  setCoverTitle,
  coverDescription,
  setCoverDescription,
  coverStyleNotes,
  setCoverStyleNotes,
  comicTitle,
  comicDescription,
  onGenerate
}) {
  if (!isOpen) return null;

  const handleGenerate = () => {
    onGenerate();
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4">
      <div className="bg-[var(--surface)] rounded-xl max-w-lg w-full">
        <div className="p-4 border-b border-[var(--border)] flex items-center justify-between">
          <h3 className="font-teko text-xl flex items-center gap-2">
            <ImagePlus className="text-green-500" size={20} />
            Generate AI Cover
          </h3>
          <button 
            onClick={onClose} 
            className="p-2 hover:bg-[var(--background)] rounded-lg"
            data-testid="cover-modal-close-btn"
          >
            <X size={20} />
          </button>
        </div>
        <div className="p-4 space-y-4">
          <div>
            <label className="text-sm text-[var(--text-secondary)]">Cover Title</label>
            <input
              type="text"
              value={coverTitle || comicTitle}
              onChange={(e) => setCoverTitle(e.target.value)}
              placeholder="Epic title for your cover"
              className="w-full mt-1 px-4 py-2 bg-[var(--background)] border border-[var(--border)] rounded-lg"
              data-testid="cover-title-input"
            />
          </div>
          <div>
            <label className="text-sm text-[var(--text-secondary)]">Story Description</label>
            <textarea
              value={coverDescription || comicDescription}
              onChange={(e) => setCoverDescription(e.target.value)}
              placeholder="Describe your story, characters, and mood..."
              rows={3}
              className="w-full mt-1 px-4 py-2 bg-[var(--background)] border border-[var(--border)] rounded-lg resize-none"
              data-testid="cover-description-input"
            />
          </div>
          <div>
            <label className="text-sm text-[var(--text-secondary)]">Style Notes (optional)</label>
            <input
              type="text"
              value={coverStyleNotes}
              onChange={(e) => setCoverStyleNotes(e.target.value)}
              placeholder="e.g., Dark fantasy, vibrant shonen, romantic..."
              className="w-full mt-1 px-4 py-2 bg-[var(--background)] border border-[var(--border)] rounded-lg"
              data-testid="cover-style-input"
            />
          </div>
        </div>
        <div className="p-4 border-t border-[var(--border)] flex justify-end gap-2">
          <button 
            onClick={onClose} 
            className="px-4 py-2 bg-[var(--background)] rounded-lg"
          >
            Cancel
          </button>
          <button 
            onClick={handleGenerate}
            className="px-4 py-2 bg-green-500 text-white rounded-lg flex items-center gap-2"
            data-testid="generate-cover-btn"
          >
            <Sparkles size={16} /> Generate Cover
          </button>
        </div>
      </div>
    </div>
  );
}

export default CoverGenerationModal;
